import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteSupplierApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteSupplier = createAsyncThunk('deleteSupplier', async (payload) => {
  return await deleteSupplierApi(payload);
});

const deleteSupplierSlice = createSlice({
  name: 'deleteSupplier', // Unique Name
  initialState,
  reducers: {
    deleteSupplierReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteSupplier.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteSupplier.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteSupplier.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteSupplierReset } = deleteSupplierSlice.actions;

export default deleteSupplierSlice.reducer;
